import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ModalTitle } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';
export const StyledModalTitle = styled(ModalTitle)`
  margin-bottom: -1rem;
`;
export const StyledTextField = styled.div`
  margin-top: 2rem;
`;
export const StyledTrial = styled.span`
  font-size: ${({
  theme
}) => theme.fonts.sizes.small};
  padding-left: 0.5rem;
`;
export const StyledAddIcon = styled(FontAwesomeIcon)`
  && {
    height: 2rem;
    width: 2rem;
  }
`;
export const StyledLabel = styled.div`
  display: flex;
`;
export const StyledDefaultLabel = styled.label<{
  $required?: boolean;
}>`
  display: inline-block;
  font-size: ${({
  theme
}) => theme.fonts.sizes.small};
  margin-bottom: 0.9rem;
`;